import { render, staticRenderFns } from "./EventUnits.vue?vue&type=template&id=5c359b36&scoped=true"
import script from "./EventUnits.vue?vue&type=script&lang=js"
export * from "./EventUnits.vue?vue&type=script&lang=js"
import style0 from "./EventUnits.vue?vue&type=style&index=0&id=5c359b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c359b36",
  null
  
)

export default component.exports